// @generated by protoc-gen-connect-query v1.4.1 with parameter "target=ts"
// @generated from file no/jotta/openapi/offer/v1/offer.proto (package no.jotta.openapi.offer.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { MethodKind } from "@bufbuild/protobuf";
import { GetOfferRequest, GetOfferResponse, GetOffersRequest, GetOffersResponse } from "./offer_pb.js";
import { PingRequest, PingResponse } from "../../ping_pb.js";
/**
 * GetOffer returns an offer for the given product. Response depends on whether the user is authenticated or not
 *
 * @generated from rpc no.jotta.openapi.offer.v1.OfferService.GetOffer
 */
export const getOffer = {
    localName: "getOffer",
    name: "GetOffer",
    kind: MethodKind.Unary,
    I: GetOfferRequest,
    O: GetOfferResponse,
    service: {
        typeName: "no.jotta.openapi.offer.v1.OfferService"
    }
};
/**
 * GetOffers returns all supported offers for the given user OR customer_group+language. Response depends on whether the user is authenticated or not
 *
 * @generated from rpc no.jotta.openapi.offer.v1.OfferService.GetOffers
 */
export const getOffers = {
    localName: "getOffers",
    name: "GetOffers",
    kind: MethodKind.Unary,
    I: GetOffersRequest,
    O: GetOffersResponse,
    service: {
        typeName: "no.jotta.openapi.offer.v1.OfferService"
    }
};
/**
 * Safe noop for testing purposes
 *
 * @generated from rpc no.jotta.openapi.offer.v1.OfferService.Ping
 */
export const ping = {
    localName: "ping",
    name: "Ping",
    kind: MethodKind.Unary,
    I: PingRequest,
    O: PingResponse,
    service: {
        typeName: "no.jotta.openapi.offer.v1.OfferService"
    }
};
